import React from "react";

interface SVGRProps {
    title?: string;
    titleId?: string;
}

const ArrowLeftShape = ({
    title,
    titleId = "tm-icon-arrowLeftShape",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        viewBox="0 0 6.89 11.31"
        width="1em"
        height="1em"
        aria-hidden={!title}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path fill="#53b6d0" d="M5.65 11.31l1.24-1.24-4.41-4.42 4.41-4.41L5.65 0 0 5.65l5.65 5.66z" />
    </svg>
);

export default ArrowLeftShape;
